// extracted by mini-css-extract-plugin
module.exports = {"container":"Description_container__1zpAA","title":"Description_title__2JNbW","description":"Description_description__3w3L3","scroll":"Description_scroll__2gBiC"};